import { __assign, __extends, __rest } from "tslib";
import classNames from 'classnames';
import React from 'react';
import ReactInputAutosize from 'react-input-autosize';
import styles from './InputAutosize.scss';
var InputAutosize = /** @class */ (function (_super) {
    __extends(InputAutosize, _super);
    function InputAutosize() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            focused: false,
            empty: !_this.props.value,
        };
        _this.handleFocus = function (event) {
            _this.setState({ focused: true });
            if (_this.props.onFocus) {
                _this.props.onFocus(event);
            }
        };
        _this.handleBlur = function (event) {
            _this.setState({ focused: false, empty: !event.target.value });
            if (_this.props.onBlur) {
                _this.props.onBlur(event);
            }
        };
        return _this;
    }
    InputAutosize.prototype.render = function () {
        var _a = this.props, className = _a.className, dataHook = _a.dataHook, props = __rest(_a, ["className", "dataHook"]);
        var empty = this.state.empty;
        return (
        // @ts-ignore
        React.createElement(ReactInputAutosize, __assign({ autoComplete: "off", "data-hook": dataHook, type: "text" }, props, { className: classNames(styles.inputWrapper, className), inputClassName: styles.input, placeholderIsMinWidth: empty, onBlur: this.handleBlur, onFocus: this.handleFocus })));
    };
    return InputAutosize;
}(React.Component));
export default InputAutosize;
//# sourceMappingURL=InputAutosize.js.map